import React, { useMemo } from "react";
import { Control, FieldValues, useFieldArray, useFormContext } from "react-hook-form";
import { Checkbox, GridLegacy, IconButton, List, ListItem, TextField, Typography } from "@mui/material";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper";
import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";
import Tooltip from "@mui/material/Tooltip";
import Button from "../../../components/CustomButtons/Button";
import { Link } from "react-router";
import Edit from "@mui/icons-material/Edit";
import { Delete } from "@mui/icons-material";
import FormElement from "../../../components/JamezzTable/FormElement";
import { ProductsList } from "../../../../../Domains/OptionGroups/Categories/ProductsInCategories";
import { FormattedNumber } from "react-intl";
import { AddChildProduct } from "./AddChildProduct.tsx";

export type ChildProduct = {
  id: number;
  key?: string;
  naam: string;
  pivot: {
    id?: number;
    is_active_in_jamezz: boolean;
    option_group_id?: number;
    price: number | null;
    sort_key: number | null;
  };
  prijs: number;
  sortkey: number | null;
};

type PartialForm = {
  child_products: ChildProduct[];
};

export default function ChildProducts() {
  const { control, vestiging } = useFormContext();
  const { fields, append, remove, replace } = useFieldArray<Partial<PartialForm>, "child_products", "key">({
    control: control as Control<FieldValues>,
    name: "child_products",
    keyName: "key",
  });
  console.log(useFormContext());

  return (
    <>
      <Card>
        <CardBody style={{ padding: 16 }}>
          <GridLegacy container spacing={1}>
            <GridLegacy item xs={12}>
              <List>
                <ListItem>
                  <GridLegacy container>
                    <GridLegacy item xs={2}>
                      <TranslationWrapper tKey={"Product name"} />
                    </GridLegacy>
                    <GridLegacy item xs={2}>
                      <TranslationWrapper tKey={"Custom price"} />
                    </GridLegacy>
                    <GridLegacy item xs={2}>
                      <TranslationWrapper tKey={"Default sort key"} />
                    </GridLegacy>
                    <GridLegacy item xs={2}>
                      <TranslationWrapper tKey={"Sort key"} />
                    </GridLegacy>
                    <GridLegacy item xs={2}>
                      <TranslationWrapper tKey={"Visible in Jamezz"} />
                    </GridLegacy>
                    <GridLegacy item xs={2} />
                  </GridLegacy>
                </ListItem>

                {fields.map((field, index) => {
                  return (
                    <ListItem>
                      <GridLegacy container>
                        <GridLegacy item xs={2}>
                          <Typography style={{ margin: "0 16px" }}>
                            {field.naam} -{" "}
                            <FormattedNumber
                              currency={vestiging?.valuta ?? "EUR"}
                              style={"currency"}
                              value={field.prijs}
                            />
                          </Typography>
                        </GridLegacy>
                        <GridLegacy item xs={2}>
                          <Typography style={{ margin: "0 16px" }}>
                            {field.pivot ? (
                              <FormElement endPoint={"core/optionGroupProducts"} name={"price"} row={field.pivot}>
                                <TextField
                                  placeholder={field.pivot?.price ?? field.prijs}
                                  size={"small"}
                                  variant={"standard"}
                                />
                              </FormElement>
                            ) : null}
                          </Typography>
                        </GridLegacy>
                        <GridLegacy item xs={2}>
                          <Typography style={{ margin: "0 16px" }}>{field.sortkey}</Typography>
                        </GridLegacy>
                        <GridLegacy item xs={2}>
                          <Typography style={{ margin: "0 16px" }}>
                            {field.pivot ? (
                              <FormElement endPoint={"core/optionGroupProducts"} name={"sort_key"} row={field.pivot}>
                                <TextField
                                  placeholder={field.pivot?.sort_key ?? field.sortkey}
                                  size={"small"}
                                  variant={"standard"}
                                />
                              </FormElement>
                            ) : null}
                          </Typography>
                        </GridLegacy>
                        <GridLegacy item xs={2}>
                          <Typography style={{ margin: "0 16px" }}>
                            {field.pivot ? (
                              <FormElement
                                askForConfirmation={false}
                                endPoint={"core/optionGroupProducts"}
                                name={"is_active_in_jamezz"}
                                parseBoolToInt={true}
                                row={field.pivot}
                                showLoadingSpinner={false}
                                valueKey={"checked"}
                              >
                                <Checkbox color={"primary"} />
                              </FormElement>
                            ) : null}
                          </Typography>
                        </GridLegacy>
                        <GridLegacy item xs={2}>
                          <IconButton
                            onClick={() => {
                              remove(index);
                            }}
                          >
                            <Delete />
                          </IconButton>

                          <Link to={`/manager/producten/${field.id}/edit`}>
                            <Tooltip
                              classes={{}}
                              placement={"bottom"}
                              title={
                                <TranslationWrapper tDefault={"View Product"} tKey={"global.jamezzTable.viewProduct"} />
                              }
                            >
                              <Button color={"success"} simple>
                                <Edit />
                              </Button>
                            </Tooltip>
                          </Link>
                        </GridLegacy>
                      </GridLegacy>
                    </ListItem>
                  );
                })}
              </List>
            </GridLegacy>
          </GridLegacy>

          <AddChildProduct append={append} fields={fields} replace={replace} />
        </CardBody>
      </Card>
      <ProductsList products={fields} />
    </>
  );
}
